import React, { useState } from "react";
import { Col, Modal, Carousel } from "react-bootstrap";
// import { FaTimes } from "react-icons/fa"; // Import an icon from react-icons
import { X as FaTimes } from "react-bootstrap-icons";

export const ImageCard = ({ images }) => {
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleShow = (index) => {
    setCurrentIndex(index);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleSelect = (selectedIndex) => {
    setCurrentIndex(selectedIndex);
  };

  return (
    <>
      {images.map((image, index) => (
        <Col size={12} sm={6} md={4} key={index}>
          <div className="image-card">
            <div
              className="image-container"
              onClick={() => handleShow(index)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={image.imgUrl}
                alt={image.title}
                className="image-preview"
              />
            </div>
            <div className="image-details">
              <h4>{image.title}</h4>
              <span>{image.description}</span>
            </div>
          </div>
        </Col>
      ))}

      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header>
          <button
            type="button"
            className="close-btn"
            onClick={handleClose}
            aria-label="Close"
            style={{
              position: "absolute",
              top: "5px",
              //   bottom: "10px",
              right: "10px",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            <FaTimes size={20} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Carousel
            activeIndex={currentIndex}
            onSelect={handleSelect}
            indicators={false}
            interval={null}
          >
            {images.map((image, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={image.imgUrl}
                  alt={image.title}
                />
                <Carousel.Caption>
                  <h5>{image.title}</h5>
                  <p>{image.description}</p>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </Modal.Body>
      </Modal>
    </>
  );
};
